import { ReactElement } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ActionButton } from '@core/components';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: ReactElement;
  buttonText: string;
  onButtonClick?: () => void;
  elevation?: number;
  hoverEffect?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  buttonText,
  onButtonClick,
  elevation = 3,
  hoverEffect = true,
}) => {
  return (
    <Paper
      elevation={elevation}
      sx={{
        borderRadius: 2,
        p: 4,
        height: '100%',
        transition: '0.2s',
        cursor: onButtonClick ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: 'column',
        ...(hoverEffect && {
          '&:hover': {
            boxShadow: 8,
            transform: 'translateY(-4px)',
          },
        }),
      }}
    >
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          sx={{
            color: 'primary.main',
            mr: 2,
            '& .MuiSvgIcon-root': {
              fontSize: 32,
            },
          }}
        >
          {icon}
        </Box>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
      </Box>
      <Typography color="text.secondary" sx={{ flex: 1, mb: 3 }}>
        {description}
      </Typography>
      {onButtonClick && (
        <Box sx={{ mt: 'auto' }}>
          <ActionButton variant="primary" fullWidth onClick={onButtonClick}>
            {buttonText}
          </ActionButton>
        </Box>
      )}
    </Paper>
  );
};

export default FeatureCard;
